import React from 'react';
import range from 'lodash/range';
import { Flex, Icon } from "../";
import { StarRatingProps } from "../../utils/propTypes";
import { isNumber } from 'lodash';

var hasRating = function hasRating(rating) {
  return isNumber(rating) || rating ? true : false;
};

var iconType = function iconType(rating, index, ratingType) {
  var ratingTypeIcon = ratingType === 'AAA' ? 'star' : 'circle';
  if (!hasRating(rating) || index < rating - 0.5) return "".concat(ratingTypeIcon);
  if (index < rating) return "".concat(ratingTypeIcon, "Half");
  return "".concat(ratingTypeIcon, "Border");
};

var renderRating = function renderRating(_ref) {
  var ratingType = _ref.ratingType,
      rating = _ref.rating,
      size = _ref.size;
  var ratingItems = [];
  var color = hasRating(rating) ? 'brightSun' : 'greys.alto';
  range(5).forEach(function (index) {
    ratingItems.push( /*#__PURE__*/React.createElement(Icon, {
      name: iconType(rating, index, ratingType),
      key: index,
      color: color,
      size: size
    }));
  });
  return ratingItems;
};

var StarRating = function StarRating(_ref2) {
  var ratingType = _ref2.ratingType,
      rating = _ref2.rating,
      size = _ref2.size;
  var title = hasRating(rating) ? "".concat(rating, " out of 5 rating") : 'No rating';
  return /*#__PURE__*/React.createElement(Flex, {
    itemType: "http://schema.org/AggregateRating",
    "aria-label": title,
    title: title
  }, renderRating({
    ratingType: ratingType,
    rating: rating,
    size: size
  }));
};

StarRating.propTypes = StarRatingProps;
export default StarRating;